import { oc } from '@orpc/contract'
import { z } from 'zod'

export const documentTagSchema = z.object({
  id: z.string().min(1),
  projectId: z.string().min(1),
  name: z.string(),
  slug: z.string(),
  color: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export const documentTagsListContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
    })
  )
  .output(
    z.object({
      items: z.array(documentTagSchema),
    })
  )

export const documentTagsCreateContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      name: z.string().min(1).max(25),
      color: z.string().optional(),
    })
  )
  .output(documentTagSchema)

export const documentTagsUpdateContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      tagId: z.string().min(1),
      name: z.string().min(1).max(25).optional(),
      color: z.string().optional(),
    })
  )
  .output(documentTagSchema)

export const documentTagsDeleteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      tagId: z.string().min(1),
    })
  )
  .output(
    z.object({
      success: z.boolean(),
    })
  )
